import __request__ from "routing/request";
export function checkCredentials(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.enterprise.integrations.onepassword.api.OnePasswordResource/onepassword/check_credentials", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.enterprise.integrations.onepassword.api.OnePasswordResource/onepassword/inputs", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
